import { type QueryClient } from '@tanstack/react-query'

import { assessmentProcessQueryKeys } from './assessmentProcessQueryClient.utils'

export interface RecommendationQueryKeyFactory {
  recommendations: {
    all: () => readonly ['recommendations']
    byAssessment: (assessmentId: string) => readonly ['recommendations', 'assessment', string]
    masterCatalog: (
      versionId: string,
      codigo: string
    ) => readonly ['recommendations', 'masterCatalog', string, string]
  }
}

export const recommendationQueryKeys: RecommendationQueryKeyFactory = {
  recommendations: {
    all: () => ['recommendations'] as const,
    byAssessment: (assessmentId) => ['recommendations', 'assessment', assessmentId] as const,
    masterCatalog: (versionId, codigo) =>
      ['recommendations', 'masterCatalog', versionId, codigo] as const
  }
}

export interface RecommendationQueryUtils {
  invalidateRecommendationQueries: (queryClient: QueryClient, assessmentId: string) => Promise<void>
}

export const recommendationQueryUtils: RecommendationQueryUtils = {
  async invalidateRecommendationQueries(queryClient, assessmentId) {
    await Promise.all([
      queryClient.invalidateQueries({
        queryKey: recommendationQueryKeys.recommendations.byAssessment(assessmentId)
      }),
      queryClient.invalidateQueries({
        queryKey: assessmentProcessQueryKeys.assessmentProcess.tree(assessmentId)
      }),
      queryClient.invalidateQueries({
        queryKey: assessmentProcessQueryKeys.assessmentProcess.canAdvance(assessmentId)
      })
    ])
  }
}
